import { render, staticRenderFns } from "./ModalSettingsOrder.vue?vue&type=template&id=068427ef&"
import script from "./ModalSettingsOrder.vue?vue&type=script&lang=js&"
export * from "./ModalSettingsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports